import { Box, Button, Card, Container, Dialog, DialogActions, TextField, Typography } from "@mui/material"
import imgTool from "../../utils/imgTool"
import '../../css/OrdersErp321.css'
import axios from "axios"
import React from "react"
import OPSLOTH_API from "../../utils/opsloth_api"
function OrdersErp321(props) {
    const [orders, setOrders] = React.useState([])
    const [currentWeek, setCurrentWeek] = React.useState({ start: '', end: '' })
    const [erpAccounts, setErpAccounts] = React.useState([])
    const [bindDialogShow, setBindDialogShow] = React.useState(false)
    const [orderItemClicked, setOrderItemClicked] = React.useState({})
    const [erp_accounts_binded, setErp_accounts_binded] = React.useState([])
    const [erp_accounts_logs_logged_ids, setErp_accounts_logs_logged_ids] = React.useState({})
    const [pageSkuIds, setPageSkuIds] = React.useState([])
    const getErp321Orders = async (currentWeek) => {
        if (currentWeek.start) {
            const ordersRes = await axios.post("https://opsloth.com/warehouse_stock/erp321_api", {
                url: "/open/orders/single/query",
                biz: {
                    shop_id: 13706993,
                    modified_begin: currentWeek.start,
                    modified_end: currentWeek.end,
                    is_get_cbfinance: 2,
                    page_size: 100,
                    date_type: 3,
                    status: 'Sent',
                    page_index: 1
                }
            })
            let sku_ids = []
            let orderItemsIds = []
            ordersRes.data.data.orders.forEach(order => {
                order.items.forEach((item, itemIndex) => {
                    sku_ids.push(item.sku_id)
                    orderItemsIds.push(order.so_id + '-' + (itemIndex + 1))
                })
            })
            setPageSkuIds(sku_ids)
            loadErpAccountsBinded(sku_ids)
            loadOrderLogged(orderItemsIds)
            setOrders(ordersRes.data.data.orders)
        }
    }

    function showBindDialog(item) {
        setOrderItemClicked(item)
        setBindDialogShow(!bindDialogShow)
    }

    async function loadOrderLogged(orderItemsIds) {//备注格式：速卖通，[订单号]-[序号]，款式
        const erp_accounts_logs_model = new OPSLOTH_API("erp_accounts_logs/aggregate")
        const erp_accounts_logs_res = await erp_accounts_logs_model.post([{
            $match: {
                deleted: { $ne: true },
                type: "周边",
                log_type: "出售",
                log_order: { $in: orderItemsIds }
            }
        }, {
            $project: {
                log_order: 1
            }
        }])
        let erp_accounts_logs_logged_ids_temp = {}
        erp_accounts_logs_res.data.forEach(item => {
            erp_accounts_logs_logged_ids_temp[item.log_order] = true
        })
        setErp_accounts_logs_logged_ids(erp_accounts_logs_logged_ids_temp)

    }

    async function orderLog(order, itemIndex) {
        const orderProducts = order.items[itemIndex]
        if (order.freight_fee && order.real_received) {
            if (checkBinded(orderProducts?.sku_id)) {
                const erp_accounts_bind = getErpAccountsBind(orderProducts?.sku_id)
                const erp_accounts_model = new OPSLOTH_API("erp_accounts" + "/" + erp_accounts_bind.erp_accounts_id)
                const erp_account_res = await erp_accounts_model.get()
                if (erp_account_res.data.stock - orderProducts?.qty >= 0) {
                    console.log("录入！")
                    let rawSum = 0
                    order.items.forEach(item => {
                        rawSum += item.base_price * item.qty
                    })
                    const log_price = (((parseFloat(order.real_received) - parseFloat(order.freight_fee)) / rawSum) * orderProducts.base_price * orderProducts.qty).toFixed(2)
                    console.log(log_price)
                    const erp_accounts_update_res = await erp_accounts_model.put({
                        $inc: { stock: -erp_accounts_bind.qty * orderProducts.qty }
                    })
                    if (erp_accounts_update_res.data.modifiedCount == 1) {
                        const erp_accounts_logs_model = new OPSLOTH_API("erp_accounts_logs")
                        const erp_accounts_logs_res = await erp_accounts_logs_model.post({
                            account_name: erp_account_res.data?.name,
                            account_id: erp_account_res.data._id,
                            log_number: erp_accounts_bind.qty * orderProducts.qty,
                            log_type: "出售",
                            log_price: log_price,
                            log_order: order.so_id + '-' + (itemIndex + 1),
                            jancode: erp_account_res.data?.jancode,
                            jancode_box: erp_account_res.data?.jancode_box,
                            log_date: order.send_date.split(" ")[0],
                            brand: erp_account_res.data?.brand,
                            type: '周边',
                            account_cost: erp_account_res.data.cost,
                            before_stock: erp_account_res.data.stock,
                            after_stock: erp_account_res.data.stock - erp_accounts_bind.qty * orderProducts.qty,
                            remark: "数量：" + erp_account_res.data.stock + ">" + (erp_account_res.data.stock - erp_accounts_bind.qty * orderProducts.qty) +
                                "\n" + "速卖通," + order.so_id + '-' + (itemIndex + 1),
                            log_user: "速卖通-" + window.user_nickname
                        })
                        if (erp_accounts_logs_res.data._id) {
                            if (log_price - erp_account_res.data.cost * erp_accounts_bind.qty * orderProducts.qty < 0) {
                                props.newAlert("录入成功！利润为负！", 'warning')
                            } else {
                                props.newAlert("录入成功！")
                            }
                            erp_accounts_logs_logged_ids[order.so_id + '-' + (itemIndex + 1)] = true
                            setErp_accounts_logs_logged_ids(erp_accounts_logs_logged_ids)
                            setOrders(orders)
                        }
                    } else {
                        alert("出错了！请检查~")
                        alert("出错了！请检查~")
                    }
                } else {
                    alert("账目2 库存不够，请手动录入！")
                }
            } else {
                alert("未绑定！")
            }
        } else {
            alert("需填写实收和运费")
        }
    }

    async function loadErpAccountsBinded(i_ids) {
        const erp_accounts_bind = new OPSLOTH_API("erp_accounts_bind/aggregate")
        const erp_accounts_bind_res = await erp_accounts_bind.post([{
            $match: { sku_id: { $in: i_ids } }
        }, {
            $project: {
                createdAt: 0,
                updatedAt: 0
            }
        }])
        setErp_accounts_binded(erp_accounts_bind_res.data)
    }

    function checkBinded(sku_id) {
        let ifBinded = false
        erp_accounts_binded.forEach(item => {
            if (item.sku_id == sku_id) {
                ifBinded = true
            }
        })
        return ifBinded
    }

    function getErpAccountsBind(sku_id) {
        let erp_account_bind = ""
        erp_accounts_binded.forEach(item => {
            if (item.sku_id == sku_id) {
                erp_account_bind = item
            }
        })
        return erp_account_bind
    }

    async function searchERPAccounts(keyword) {
        const erp_accounts = new OPSLOTH_API("erp_accounts")
        const erp_accounts_res = await erp_accounts
            .setFilter({ deleted: { $ne: true }, $or: [{ name: { $regex: keyword } }, { jancode: { $regex: keyword } }, { jancode_box: { $regex: keyword } }] })
            .setField("name jancode jancode_box stock cost")
            .setOptions({ limit: 30, sort: '-createdAt' })
            .get()
        setErpAccounts(erp_accounts_res.data)
    }

    async function bindERPAccount(event, erp_account, orderItemClicked) {
        if (erp_account?.qty <= 0) {
            alert("未输入绑定数量")
        } else {
            const erp_accounts_bind = new OPSLOTH_API("erp_accounts_bind")
            const erp_account_bind_res = await erp_accounts_bind.post({
                erp_accounts_id: erp_account._id,
                erp_accounts_name: erp_account.name,
                taobao_id: orderItemClicked.i_id,
                sku_id: orderItemClicked.sku_id,
                qty: erp_account?.qty ?? 1, // TODO 默认参数设置 input
                jancode: erp_account.jancode,
                jancode_box: erp_account.jancode_box
            })
            if (erp_account_bind_res.data._id) {
                props.newAlert('绑定成功！')
                loadErpAccountsBinded(pageSkuIds)
            }
        }
    }

    function formatDate(date) {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    function getWeekStartAndEnd(date) {
        const today = date || new Date(); // 使用传入的日期，如果没有则使用当前日期
        const currentDay = today.getDay();
        const diff = today.getDate() - currentDay + (currentDay === 0 ? -6 : 1); // 计算与周一的日期差
        const monday = new Date(today.setDate(diff));
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        const resultWeek = {
            start: formatDate(monday) + ' 00:00:00',
            end: formatDate(sunday) + ' 23:59:59'
        }
        setCurrentWeek(resultWeek)
        return resultWeek;
    }

    function getPreviousWeekStartAndEnd() {
        const monday = new Date(currentWeek.start);
        const previousMonday = new Date(monday);
        previousMonday.setDate(monday.getDate() - 7);
        const previousSunday = new Date(previousMonday);
        previousSunday.setDate(previousMonday.getDate() + 6);

        const resultWeek = {
            start: formatDate(previousMonday) + ' 00:00:00',
            end: formatDate(previousSunday) + ' 23:59:59'
        }
        setCurrentWeek(resultWeek)
        return resultWeek;
    }

    function getNextWeekStartAndEnd() {
        const monday = new Date(currentWeek.start);
        const nextMonday = new Date(monday);
        nextMonday.setDate(monday.getDate() + 7);
        const nextSunday = new Date(nextMonday);
        nextSunday.setDate(nextMonday.getDate() + 6);
        const resultWeek = {
            start: formatDate(nextMonday) + ' 00:00:00',
            end: formatDate(nextSunday) + ' 23:59:59'
        }
        setCurrentWeek(resultWeek)
        return resultWeek;
    }
    React.useEffect(() => {
        getWeekStartAndEnd()
    }, [])

    React.useEffect(() => {
        getErp321Orders(currentWeek)
    }, [currentWeek])

    React.useEffect(() => {
        if (!bindDialogShow) {
            setOrderItemClicked({})
            setErpAccounts([])
        }
    }, [bindDialogShow])


    return <Container width='xl'>
        <Card sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box>
                <TextField variant='standard' size='small' type='date' sx={{m:1}} value={currentWeek.start.split(' ')[0]} onChange={(event)=>{getWeekStartAndEnd(new Date(event.target.value))}}></TextField>
                <Button>~</Button>
                <TextField variant='standard' disabled={true} size='small' type='date' sx={{m:1}} value={currentWeek.end.split(' ')[0]}></TextField>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <Button onClick={() => { console.log(getPreviousWeekStartAndEnd()) }}>上一周</Button>
                <Button onClick={() => { console.log(getWeekStartAndEnd()) }}>获取当前周</Button>
                <Button onClick={() => { console.log(getNextWeekStartAndEnd()) }}>下一周</Button>
            </Box>
        </Card>
        <Typography sx={{mt:2}}>当前页订单数 {orders.length}</Typography>
        <Card sx={{ my: 2, p: 1 }}>
            {
                orders.map((order, orderIndex) =>
                    <Box sx={{ m: 2 }} key={order.so_id}>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            <Typography>{orderIndex + 1}. 订单号：{order.so_id}，发货日期：{order.send_date}</Typography>
                            <Typography sx={{ fontWeight: 'bold' }}>订单金额：￥{order.paid_amount}</Typography>
                            <input key={'real_received' + order.so_id} onInput={(event) => {
                                order.real_received = event.target.value
                            }} value={order.real_received} placeholder="实收" style={{ width: "4em" }} type="number" />

                            <input key={'freight_fee' + order.so_id} onInput={(event) => {
                                order.freight_fee = event.target.value
                            }} value={order.freight_fee} placeholder="运费" style={{ width: "4em" }} type="number" />
                            <Typography sx={{ color: order.labels.indexOf("售后") >= 0 || order.labels.indexOf("纠纷") >= 0 ? 'red' : 'none' }}>{order.labels}</Typography>
                            <Typography sx={{ color: 'red' }}>{order.remark}</Typography>
                            {order?.merge_so_id?.split(',').map(item => {
                                return <Typography sx={{ color: 'orange' }}>{'合并订单：' + item.split(':')[1]}</Typography>
                            })}
                        </Box>
                        {
                            order.items.map((item, itemIndex) =>
                                <Box sx={{ display: 'flex', m: 1, }} key={order.so_id + item.sku_id}>
                                    <Typography sx={{ alignContent: 'space-evenly', px: .5, mx: .5, background: '#f7f4f4' }}>{itemIndex + 1}</Typography>
                                    <Typography onClick={() => { showBindDialog(item) }} className="buttonHover" sx={{ alignContent: 'space-evenly', px: .5, mx: .5, width: '1em', background: checkBinded(item.sku_id) ? '#d0e8ff' : '#f4f4f4', cursor: 'pointer' }}>绑定</Typography>
                                    <Typography onClick={() => { orderLog(order, itemIndex) }} className="buttonHover" sx={{ alignContent: 'space-evenly', px: .5, mx: .5, width: '1em', pointerEvents: erp_accounts_logs_logged_ids[order.so_id + '-' + (itemIndex + 1)] ? 'none' : 'all', background: erp_accounts_logs_logged_ids[order.so_id + '-' + (itemIndex + 1)] ? '#d0e8ff' : '#f4f4f4', cursor: 'pointer' }}>录入</Typography>
                                    {/* <img height={100} width={100} style={{ objectFit: 'contain' }} src={imgTool.getSmallerImgUrl("https://cdn.cms.opsloth.com:443/2025-02/17391734504665%E6%9C%88Qualia%E6%83%85%E5%A0%B1%E6%9B%B8(%E6%B5%B7%E5%A4%96%E3%81%AC%E3%81%84%E3%81%90%E3%82%8B%E3%81%BF)%E2%80%BB%E7%84%A1%E6%96%AD%E6%8E%B2%E8%BC%89%E7%A6%81%E6%AD%A2_06.jpg")} /> */}
                                    <img height={100} width={100} style={{ objectFit: 'contain' }} src={imgTool.getSmallerImgUrl(item.pic)} />
                                    <Box sx={{ display: 'flex', flexDirection: 'column', m: .5 }}>
                                        <Typography>{item.name}</Typography>
                                        <Typography variant="body2">{item.properties_value}</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>款式编码：{item.i_id}，商品编码：{item.sku_id}</Typography>
                                        <Box sx={{ display: 'flex' }}>
                                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: item.qty > 1 ? '#ff6400' : 'none' }}>{item.qty} x </Typography>
                                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>￥{item.base_price}</Typography>
                                        </Box>
                                        <Typography></Typography>
                                    </Box>
                                </Box>
                            )
                        }
                    </Box>
                )
            }
        </Card>
        <Dialog open={bindDialogShow}
            fullWidth={true}
            maxWidth="lg"
            onClose={() => { setBindDialogShow(false) }}
        >
            <Container sx={{ p: 2 }}>
                <Typography>{orderItemClicked?.name}</Typography>
                <Typography>{orderItemClicked?.properties_value}</Typography>
                <Typography sx={{ fontWeight: 'bold' }}>款式编码：{orderItemClicked?.i_id} 商品编码：{orderItemClicked?.sku_id}</Typography>
                <Typography>{getErpAccountsBind(orderItemClicked?.sku_id).qty ? getErpAccountsBind(orderItemClicked?.sku_id).qty + ' x ' + getErpAccountsBind(orderItemClicked?.sku_id).erp_accounts_name + ' JANCODE：' + getErpAccountsBind(orderItemClicked?.sku_id).jancode : ''} </Typography>
                <TextField
                    size="small"
                    placeholder="搜索账目2"
                    fullWidth={true}
                    sx={{ my: 1 }}
                    onKeyDown={event => {
                        if (event.which === 13) {
                            searchERPAccounts(event.target.value)
                        }
                    }}
                />
                {
                    erpAccounts.map((erp_account, erp_account_index) => {
                        return <Box sx={{ my: 2 }} key={erp_account._id}>
                            <Typography>{erp_account.name}</Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <TextField defaultValue={1} sx={{ width: '4em' }} size="small" type="number" data-index={erp_account_index} onInput={(event) => {
                                    erp_account.qty = parseInt(event.target.value)
                                }} />
                                <Typography>库存：{erp_account.stock} 成本：{erp_account.cost}元 JANCODE：{erp_account.jancode}{erp_account.jancode_box ? ' JANCODE_BOX：' + erp_account.jancode_box : ''}</Typography>
                                <Button variant="contained" sx={{ background: '#6aa6eb' }} onClick={(event) => bindERPAccount(event, erp_account, orderItemClicked)}>绑定</Button>
                            </Box>
                        </Box>
                    })
                }
            </Container>
        </Dialog>
    </Container >
}

export default OrdersErp321